import { Injectable, signal } from '@angular/core';
import { ISidebar } from '@models/ISidebar';

interface SideBarItemInput {
  id: number;
  apartado: string;
  nombre: string;
  accion: string;
  controlador: string;
  icon?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SidebarService {


  constructor(
  ) { }

  isOpen = signal(false);

  sideBarTooggle() {
    this.isOpen.set(!this.isOpen());
  }

  // TODO => HACER JSON TRADUCCIONES BASANDOME EN ESTO NUEVO
  transformarSidebar(items: SideBarItemInput[]): ISidebar[] {
    // Agrupamos por controlador
    const grupos = items.reduce((acc, item, index) => {
      if (!acc[item.controlador]) acc[item.controlador] = [];
      acc[item.controlador].push({ ...item, originalIndex: index });
      return acc;
    }, {} as Record<string, (SideBarItemInput & { originalIndex: number })[]>);

    let idCounter = 1;
    const resultado: ISidebar[] = [];

    for (const [controlador, grupoItems] of Object.entries(grupos)) {
      if (grupoItems.length === 1) {
        // Solo un item, sin subLabel
        const item = grupoItems[0];
        resultado.push({
          id: idCounter++,
          label: item.nombre,
          url: `/${item.controlador}/${item.accion}`,
          traduccion: item.nombre.replace(/\s+/g, "").toLocaleUpperCase()
        });
      } else {
        // Más de un item, el controlador es label padre y los items hijos en subLabel
        const subLabels: ISidebar[] = grupoItems.map((item) => ({
          id: idCounter++,
          label: item.nombre,
          url: `/${item.controlador}/${item.accion}`,
          traduccion: item.nombre.replace(/\s+/g, "").toLocaleUpperCase()
        }));

        resultado.push({
          id: idCounter++,
          label: controlador,
          subLabel: subLabels,
          traduccion: controlador.replace(/\s+/g, "").toLocaleUpperCase()
        });
      }
    }

    return resultado;
  }

}
